"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSiteForHost = void 0;
var normalizeHost = function (host) {
    return host
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, "")
        .replace(/:\d+$/, "")
        .replace(/\/.*$/, "")
        .replace(/\.$/, "");
};
var stripWww = function (host) {
    return normalizeHost(host).replace(/^www\./, "");
};
var normalizeKey = function (value) {
    return value.toLowerCase().replace(/[^a-z0-9]/g, "");
};
/**
 * Attempts to resolve the best matching site for a host using the full
 * list of sites. It checks explicit domain lists on the site config
 * with an exact match first, then falls back to matching by slug/name.
 */
var findSiteForHost = function (host, sites) {
    if (!host || !Array.isArray(sites))
        return null;
    var normalizedHost = stripWww(host);
    var hostLabel = normalizedHost.split(".")[0] || normalizedHost;
    var hostKey = normalizeKey(hostLabel);
    // 1) Check explicit domain lists if present on site config
    for (var _i = 0, sites_1 = sites; _i < sites_1.length; _i++) {
        var site = sites_1[_i];
        var domains = (site.domains || []).filter(function (domain) { return typeof domain === "string"; });
        if (domains.length === 0)
            continue;
        var normalizedDomains = domains.map(stripWww).filter(Boolean);
        // Prefer exact host matches
        if (normalizedDomains.some(function (d) { return d === normalizedHost; })) {
            return site;
        }
        // Allow subdomains of configured domains
        if (normalizedDomains.some(function (d) { return normalizedHost.endsWith(".".concat(d)); })) {
            return site;
        }
    }
    // 2) Match by slug ignoring separators
    for (var _a = 0, sites_2 = sites; _a < sites_2.length; _a++) {
        var site = sites_2[_a];
        if (!site.slug)
            continue;
        var slugKey = normalizeKey(site.slug);
        if (slugKey && slugKey === hostKey)
            return site;
    }
    // 3) Match by site name as a last resort
    for (var _b = 0, sites_3 = sites; _b < sites_3.length; _b++) {
        var site = sites_3[_b];
        if (!site.name)
            continue;
        var nameKey = normalizeKey(site.name);
        if (!nameKey)
            continue;
        if (nameKey === hostKey ||
            hostKey === nameKey ||
            nameKey.includes(hostKey) ||
            hostKey.includes(nameKey)) {
            return site;
        }
    }
    return null;
};
exports.findSiteForHost = findSiteForHost;
